export const MMKVStoreKeyMap = {
    discoveryStore: 'discoveryStore',
};
  